
export const PAYMENT_ENDPOINTS = {
  // ============ PUBLIC ENDPOINTS ============
  STATUS: { 
    path: `/payments/status`, 
    method: "GET" 
  },

  CREATE_PAYMENT_LINK: { 
    path: `/payments/createpaymentlink`, 
    method: "POST" 
  },
  
  HAS_PAYMENT_LINK: { 
    path: `/payments/haspaymentlink`, 
    method: "GET" 
  },
  
  PAY_NOW: { 
    path: `/payments/pay`, 
    method: "GET" 
  },
  
  PAYMENT_CALLBACK: { 
    path: `/payments/callback`, 
    method: "GET" 
  },
  
  WEBHOOK: { 
    path: `/payments/webhook`, 
    method: "POST" 
  },
  
  GET_BY_ENTITY: { 
    path: `/payments/entity`, 
    method: "GET" 
  },

  // ============ ADMIN ENDPOINTS ============
  ADMIN_GET_ALL_PAYMENTS: {
    path: `/payments/admin/getallpayments`,
    method: "GET",
  },

  ADMIN_GET_PAYMENT_BY_ID: {
    path: `/payments/admin/:id`,
    method: "GET",
  },

  ADMIN_UPDATE_PAYMENT: {
    path: `/payments/admin/:id`,
    method: "PUT",
  },

  ADMIN_DELETE_PAYMENT: {
    path: `/payments/admin/:id`,
    method: "DELETE",
  },

  ADMIN_REFUND_PAYMENT: {
    path: `/payments/admin/:id/refund`,
    method: "POST",
  },

  ADMIN_GET_STATS: {
    path: `/payments/admin/stats`,
    method: "GET",
  },

  // ============ BML SPECIFIC ============
  BML_HEALTH: {
    path: `/payments/bml/health`,
    method: "GET",
  },

  BML_CREATE: {
    path: `/payments/bml/create`,
    method: "POST",
  },

  BML_VERIFY: {
    path: `/payments/bml/verify`,
    method: "GET",
  },

  BML_CALLBACK: {
    path: `/payments/bml/callback`,
    method: "GET",
  },

  BML_WEBHOOK: {
    path: `/payments/bml/webhook`,
    method: "POST",
  },
} as const;